import * as types from '../mutation-types'
import api from '../api'
import Vue from 'vue'

const defaultState = () => ({
    addresses: [],
    brands: [],
    mainAddress: {},
    billingAddress: {},
    forwardingAddresses: {
        active: {},
        default: {},
        future_default: {},
        punctual: {},
    },

    representatives: [],

    contracts: [],

    orders: [],
    order: {},
    validation_requests: [],
    balance: {},
    expected_documents:[],
    internal_documents:[],
    exportToErpReport: null,
    representativeManificationForm: {},

    manual_notifications: [],

    sap_organizations: [],

    loyaltyProgramSubscriptions: [],

    mailScans: [],

    socialCertificate: {},

    isUpdatingSAP: false
})

const state = {
    fetching: false,
    id: null,
    profile: {},

    ...defaultState()
}

const mutations = {
    [types.FETCHING_SWITCH](state) {
        state.fetching = !state.fetching
    },

    [types.CUSTOMER_RECEIVED](state, payload) {
        state.profile = _.assign({}, payload)
        state.id = payload.id
        _.forEach(["representatives", "contracts", "buyers"], (prop) => {
            if (_.has(payload, prop))
                state[prop] = payload[prop]
        })
        payload.adresses = []
        payload.mainAddress = {}
        state = _.assign({}, state, defaultState())
    },

    [types.MAIN_ADDRESS_RECEIVED](state, payload) {
        Vue.set(state, "mainAddress", payload.address)
    },

    [types.CUSTOMER_INTERMEDIARY_BUSINESS_RECEIVED](state, payload) {
        Vue.set(state, "intermediaryBusiness", payload.intermediary_business)
    },

    [types.CUSTOMER_INTERMEDIARY_BUSINESS_REMOVED](state, payload) {
        Vue.set(state, "intermediaryBusiness", payload)
    },

    [types.CUSTOMER_INTERMEDIARY_BUSINESS_ADDED](state, payload) {
        Vue.set(state, "intermediaryBusiness", payload)
    },

    [types.BILLING_ADDRESS_RECEIVED](state, payload) {
        Vue.set(state, "billingAddress", payload.address)
    },

    [types.ADDRESSES_RECEIVED](state, payload) {
        Vue.set(state, "addresses", payload.addresses)
    },

    [types.REPRESENTATIVES_RECEIVED](state, payload) {
        Vue.set(state, "representatives", payload.representatives)
    },

    [types.CONTRACTS_RECEIVED](state, payload) {
        Vue.set(state, "contracts", payload)
    },

    [types.ORDERS_RECEIVED](state, payload) {
        Vue.set(state, "orders", payload.orders)
    },

    [types.ORDER_RECEIVED](state, payload) {
        Vue.set(state, "order", payload.order)
    },

    [types.ACTIVE_FORWARDING_ADDRESS_RECEIVED](state, payload) {
        Vue.set(state.forwardingAddresses, "active", payload)
    },

    [types.DEFAULT_FORWARDING_ADDRESS_RECEIVED](state, payload) {
        Vue.set(state.forwardingAddresses, "default", payload)
    },

    [types.FUTURE_DEFAULT_FORWARDING_ADDRESS_RECEIVED](state, payload) {
        Vue.set(state, "forwardingAddresses.future_default", payload.address)
    },

    [types.PUNCTUALS_FORWARDING_ADDRESSES_RECEIVED](state, payload) {
        Vue.set(state, "forwardingAddresses.punctual", payload.address)
    },

    [types.CUSTOMER_COMMENTS_CHANGED](state, payload) {
        // state.profile.comments = payload
        state.profile = _.assign({}, state.profile, { comments: payload })
    },

    [types.CUSTOMER_DEFAULT_BUYER_UPDATED](state, buyer) {
        Vue.set(state.profile, 'default_buyer', buyer)
    },

    [types.CUSTOMER_CHANGED](state, payload) {
        state.profile = {
            ...state.profile,
            ...payload.customer
        }
    },

    // [types.REPRESENTATIVE_REMOVED] (state, id) {
    //   state.representatives = _.filter(
    //     state.representatives,
    //     (rep) => rep.representative_id !== id
    //   )
    // },

    // FIXME: Le payload ne semble pas retourner suffisemment d'éléments pour le bon fonctionnement de la suite
    // payload ne contient que result.status...
    [types.SEND_TO_SAP_COMPLETED](state, payload) {
        Vue.set(state, "exportToErpReport", payload)
        state.profile = _.assign({}, state.profile, payload.result.customer)
        if (payload.result.status = 'success') { state.isUpdatingSAP = false }
    },

    [types.BRANDS_RECEIVED](state, payload) {
        Vue.set(state, "brands", payload)
    },

    [types.BRAND_ADDED](state, payload) {
        state.brands.push(payload)
    },

    [types.BRAND_REMOVED](state, payload) {
        state.brands = _.filter(state.brands, (brand) => brand.id !== payload.id)
    },

    [types.BRAND_ARCHIVED](state, payload) {
        state.brands = _.filter(state.brands, (brand) => brand.id !== payload.id)
    },

    [types.REPRESENTATIVE_MAINIFICATION_FORM_RECEIVED](state, payload) {
        state.representativeManificationForm = _.assign({}, payload)
        //Vue.set(state, "representativeManificationForm", payload)
        //state.brands = _.filter(state.brands, (brand) => brand.id !== payload.id)
    },

    [types.BALANCE_RECEIVED](state, payload) {
        state.balance = payload.balance_state
    },
    
    [types.CUSTOMER_EXPECTED_DOCUMENTS_FETCHED](state, payload) {
        state.expected_documents = payload.expected_documents
    },
    
    [types.CUSTOMER_INTERNAL_DOCUMENTS_FETCHED](state, payload) {
        state.internal_documents = payload.customer_internal_documents
    },

    [types.HIGHLIGHT_ORDER](state, orderId) {
        state.highlighted_order = orderId
    },

    [types.CUSTOMER_MANUAL_NOTIFICATIONS_RETRIEVED](state, payload) {
        state.manual_notifications = payload.manual_notifications
    },

    // [types.REPRESENTATIVE_CHANGED] (state, model) {
    //   let idx = _.findIndex(state.representatives, [ 'representative_id', model.representative_id ])
    //   state.representatives[idx] = model
    // },

    [types.CUSTOMER_SAP_ORGANIZATIONS_RECEIVED](state, payload) {
        Vue.set(state, "sap_organizations", payload.sap_organizations)
    },

    [types.CUSTOMER_LOYALTY_PROGRAM_SUBSCRIPTIONS_RETRIEVED] (state, payload) {
        state.loyaltyProgramSubscriptions = payload.loyalty_program_subscriptions
    },

    [types.CUSTOMER_MAIL_SCANS_FETCHED](state, payload) {
        state.mailScans = payload.mail_scans
    },
    
    SET_SOCIAL_CERTIFICATE(state, payload) {
        state.socialCertificate = payload.social_certificate
    }
}

const actions = {
    // fetch data for a customer given its id
    fetchCustomer({ commit }, id) {
        return api.getCustomer(id)
            .then(response => commit(types.CUSTOMER_RECEIVED, response.data.customer))
    },

    updateDefaultBuyer({ commit }, { customerId, buyer }) {
        return api.updateDefaultBuyer(customerId, buyer.id)
            .then(() => commit(types.CUSTOMER_DEFAULT_BUYER_UPDATED, buyer))
    },

    fetchMainAddress({ commit }) {
        commit(types.MAIN_ADDRESS_RECEIVED, {})
        return api.getMainAddress(state.id)
            .then(response => commit(types.MAIN_ADDRESS_RECEIVED, response.data))
    },

    fetchBillingAddress({ commit }) {
        return api.getBillingAddress(state.id)
        .then(response => commit(types.MAIN_ADDRESS_RECEIVED, response.data))
    },

    fetchAddresses({ commit }) {
        return api.getAddresses(state.id)
        .then(response => commit(types.ADDRESSES_RECEIVED, response.data))
    },

    fetchRepresentatives({ commit }) {
        return api.getRepresentatives(state.id)
        .then(response => commit(types.REPRESENTATIVES_RECEIVED, response.data))
    },

    fetchContracts({ commit }, params) {
        let contracts = null

        return api.getContracts(state.id, {search: params.search, with:params.with})
            .then(response => {
                contracts = _.orderBy(response.data.contracts, ['decoded_status'],['asc']);
                commit(types.CONTRACTS_RECEIVED, contracts)
            })
    },

    fetchBrands({ commit }) {
        return api.getBrands(state.id)
        .then(response => commit(types.BRANDS_RECEIVED, response.data.customer_brands))
    },

    fetchOrders({ commit }, params) {
        if (!params) {
            params = {}
        }

        const requestParams = Object.assign({}, { paginate: 0, recovery_data: 1 }, params)

        return api.getOrders(state.id, requestParams)
        .then(response => commit(types.ORDERS_RECEIVED, response.data))
    },

    fetchOrder({ commit }, orderId) {
        return api.getOrder(state.id, orderId)
        .then(response => commit(types.ORDER_RECEIVED, response.data))
    },

    fetchForwardingAddress({ commit }, { contractId, contractMailOptionId }) {
        return api.getActiveMailForwardingAddress(
            contractId,
            contractMailOptionId
        ).then(response => {
            commit(
                types.ACTIVE_FORWARDING_ADDRESS_RECEIVED,
                response.data.address
            )
            return response.data
        })
    },

    fetchIntermediaryBusiness({ commit }) {
        commit(types.CUSTOMER_INTERMEDIARY_BUSINESS_RECEIVED, {})
        return api.getIntermediaryBusiness(state.id)
            .then(response => commit(types.CUSTOMER_INTERMEDIARY_BUSINESS_RECEIVED, response.data))
    },

    removeIntermediaryBusiness({ commit, state }) {
        return api.removeIntermediaryBusiness(state.id)
            .then(response => commit(types.CUSTOMER_INTERMEDIARY_BUSINESS_REMOVED, null))
    },

    addIntermediaryBusiness({ commit, dispatch, state }, model) {
        return api.addIntermediaryBusiness(state.id, model)
            .then(response => {
                const newIntermediaryBusiness = response.data.intermediary_business
                commit(types.CUSTOMER_INTERMEDIARY_BUSINESS_ADDED, newIntermediaryBusiness)
            })
    },

    updateCustomerComments({ commit, dispatch }, comments) {
        return api.updateCustomerComments(state.id, comments)
            .then(response => commit(types.CUSTOMER_COMMENTS_CHANGED, comments))
    },

    updateCustomer({ commit, dispatch }, model) {
        // NOTE: temporary workaround
        model.validation_override = __REQUESTS_VALIDATION_OVERRIDE__
        return api.updateCustomer(state.id, model)
            .then(response => commit(types.CUSTOMER_CHANGED, model))
            .then(() => dispatch('fetchCustomer', state.id))
            .then(() => dispatch('fetchAddresses'))
    },

    addAddress({ commit, dispatch }, address) {
        return api.storeCustomerAddress(state.id, address)
            // .then(response => commit(types.ADDRESS_ADDED, address))
            .then(response => dispatch('fetchAddresses'))
    },

    updateAddress({ commit, dispatch }, model) {
        // debugger
        return api.updateAddress(state.id, model.address.id, model)
            .then(response => dispatch('fetchAddresses'))
    },

    addRepresentative({ commit }, representative) {
        return api.addCustomerRepresentative(state.id, representative)
            .then(response => commit(types.REPRESENTATIVE_ADDED, representative))
    },

    updateRepresentative({ commit, dispatch }, model) {
        return api.updateRepresentative(state.id, model)
            .then(response => dispatch('fetchRepresentatives'))
    },

    updateRepresentativeInfo({ commit, dispatch }, model) {
        return api.updateRepresentativeInfo(state.id, model)
            .then(response => dispatch('fetchRepresentatives'))
    },

    updateRepresentativeAddress({ commit, dispatch }, model) {
        return api.updateRepresentativeAddress(state.id, model)
            .then(response => dispatch('fetchRepresentatives'))
    },

    terminateRepresentative({ commit, dispatch }, model) {
        const representativeId = model.representative_id

        model.validation_override = __REQUESTS_VALIDATION_OVERRIDE__
        return api.terminateRepresentative(state.id, representativeId, model)
            .then(response => dispatch('fetchRepresentatives'))
    },

    mainifyRepresentative({ commit, dispatch }, { representativeId, payload }) {
        return api.mainifyRepresentative(state.id, representativeId, { validation_override: __REQUESTS_VALIDATION_OVERRIDE__, ...payload })
            .then(() => dispatch("fetchRepresentatives"))
    },

    sendToSAP({ commit, dispatch, state }) {
        Vue.set(state, "isUpdatingSAP", true)
        return api.storeCustomerErpRecord(state.id)
            .then(response => commit(types.SEND_TO_SAP_COMPLETED, response.data))
    },

    addBrand({ commit, dispatch, state }, model) {
        return api.addBrand(state.id, model)
            .then(response => {
                const newBrand = response.data.customer_brand
                commit(types.BRAND_ADDED, newBrand)
            })
    },

    archiveBrand({ commit, state }, model) {
        return api.archiveBrand(state.id, model.id)
            .then(response => commit(types.BRAND_ARCHIVED, model))
    },

    removeBrand({ commit, state }, model) {
        return api.removeBrand(state.id, model.id)
            .then(response => commit(types.BRAND_REMOVED, model))
    },

    fetchRepresentativeMainificationForm({ commit }, representativeId) {
        return api.getRepresentativeMainificationForm(state.id, representativeId)
            .then(response => commit(types.REPRESENTATIVE_MAINIFICATION_FORM_RECEIVED, response.data.form))
    },

    fetchBalance({ commit }, params) {
        commit(types.BALANCE_RECEIVED, {})
        return api.get_balance(params.customerId, {refresh:params.refresh})
            .then(response => commit(types.BALANCE_RECEIVED, response.data))
    },

    fetchExpectedDocuments({ commit }) {
        const params = {}

        return api.getCustomerExpectedDocuments(state.id, params)
            .then(response => commit(types.CUSTOMER_EXPECTED_DOCUMENTS_FETCHED, response.data))
    },

    fetchInternalDocuments({ commit }) {
        const params = {}

        return api.getCustomerInternalDocuments(state.id, params)
            .then(response => commit(types.CUSTOMER_INTERNAL_DOCUMENTS_FETCHED, response.data))
    },

    set_available_idxs({commit, rootState}, arr) {
      rootState.tabs.customer.available_tabs_indexes = arr
    },

    getCustomerManualNotifications({commit}, customerId) {
        return api.getCustomerManualNotifications(customerId)
            .then(response => commit(types.CUSTOMER_MANUAL_NOTIFICATIONS_RETRIEVED, response.data))
    },

    fetchSapOrganizations({ commit }) {
        return api.getCustomerSapOrganizations(state.id, {with: 'organization;payment_method'})
        .then(response => commit(types.CUSTOMER_SAP_ORGANIZATIONS_RECEIVED, response.data))
    },

    fetchLoyaltyProgramSubscriptions({ commit }, params) {
        return api.getLoyaltyProgramSubscriptions(params)
            .then(response => commit(types.CUSTOMER_LOYALTY_PROGRAM_SUBSCRIPTIONS_RETRIEVED, response.data))
    },

    fetchSocialCertificate({ commit }) {
        return api.getCustomerSocialCertificate(state.id)
            .then(response => commit('SET_SOCIAL_CERTIFICATE', response.data))
    },

    updateSocialCertificate({state, dispatch}, model) {
        return api.updateCustomerSocialCertificate(state.id, model)
            .then(response => dispatch('fetchSocialCertificate'))
    },

    fetchMailScans({ commit }, params) {
        if (!params) {
            params = {}
        }

        const requestParams = Object.assign({}, { orderBy: 'registered_at', sortedBy: 'desc' }, params)

        return api.getCustomerMailScans(state.id, requestParams)
            .then(response => commit(types.CUSTOMER_MAIL_SCANS_FETCHED, response.data))
    }
}

const getters = {
    isProspect(state) {
        return !state.profile.stored_in_erp
    },

    filteredBrands(state) {
        return {
            active: _.filter(state.brands, ['archived', false]),
            old: _.filter(state.brands, 'archived')
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./client/store/modules/customer.js